import { RouteObject } from 'react-router-dom'
import { CreateMessagePage } from './pages/CreateMessagePage'
import { MessageCampaignsPage } from './pages/MessageCampaignsPage'
import { CreateAutoMessagePage } from './pages/CreateAutoMessagePage'
import { ManageAutoMessagesPage } from './pages/ManageAutoMessagesPage'
import { EditAutoMessagePage } from './pages/EditAutoMessagePage'
import { ChannelTransactionsPage } from './pages/ChannelTransactionsPage'
import { CreateIntervalMessagePage } from './pages/CreateIntervalMessagePage'
import { ManageIntervalMessagesPage } from './pages/ManageIntervalMessagesPage'
import { EditIntervalMessagePage } from './pages/EditIntervalMessagePage'
import { MessagingAnalyticsPage } from './pages/MessagingAnalyticsPage'
import FlexMessageAnalyticsPage from './pages/FlexMessageAnalyticsPage'
import BrokeFlexAnalyticsPage from './pages/BrokeFlexAnalyticsPage'
import { ManageBrokeFlexMessagePage } from './pages/ManageBrokeFlexMessagePage'
import { CreateBrokeFlexMessagePage } from './pages/CreateBrokeFlexMessagePage'
import { EditBrokeFlexMessagePage } from './pages/EditBrokeFlexMessagePage'

export const messagingRoutes: RouteObject[] = [
	{
		path: 'messaging/create',
		element: <CreateMessagePage />,
	},
	{
		path: 'messaging/campaigns',
		element: <MessageCampaignsPage />,
	},
	{
		path: 'messaging/auto/create',
		element: <CreateAutoMessagePage />,
	},
	{
		path: 'messaging/auto',
		element: <ManageAutoMessagesPage />,
	},
	{
		path: 'messaging/auto/:id',
		element: <EditAutoMessagePage />,
	},
	{
		path: 'messaging/interval/create',
		element: <CreateIntervalMessagePage />,
	},
	{
		path: 'messaging/interval',
		element: <ManageIntervalMessagesPage />,
	},
	{
		path: 'messaging/interval/:id',
		element: <EditIntervalMessagePage />,
	},
	{
		path: 'messaging/transactions',
		element: <ChannelTransactionsPage />,
	},
	{
		path: 'messaging/analytics',
		element: <MessagingAnalyticsPage />,
	},
	{
		path: 'messaging/flex-analytics',
		element: <FlexMessageAnalyticsPage />,
	},
	{
		path: 'messaging/broke-flex-analytics',
		element: <BrokeFlexAnalyticsPage />,
	},
	{
		path: 'messaging/broke-flex-message',
		element: <ManageBrokeFlexMessagePage />,
	},
	{
		path: 'messaging/broke-flex-message/create',
		element: <CreateBrokeFlexMessagePage />,
	},
	{
		path: 'messaging/broke-flex-message/:id',
		element: <EditBrokeFlexMessagePage />,
	},
]
